import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons";

import { Icon } from "@/components/Icon/Icon";

interface MappingRequirementsHintProps {
	combinations: string[][];
}

export const MappingRequirementsHint: FunctionComponent<MappingRequirementsHintProps> = ({
	combinations,
}) => {
	const { t } = useTranslation();

	if (!combinations.length) {
		return null;
	}

	const separator = t("csvEnrichment.mappingHint.separator");

	return (
		<div className="flex items-start gap-2 text-text-meta text-xs max-w-[60%]">
			<Icon className="text-text-meta w-3.5 h-3.5 mt-0.5 flex-shrink-0" icon={faInfoCircle} />
			<div>
				<div className="font-semibold text-text">{t("csvEnrichment.mappingHint.title")}</div>
				<ul className="list-disc pl-4 mt-1">
					{combinations.map((combo, idx) => (
						<li key={idx}>{combo.join(separator)}</li>
					))}
				</ul>
			</div>
		</div>
	);
};
